import { Badge } from '@/components/ui/badge';
import { getDisplayProfileName, getProfileColorClass } from '@/utils/transforms';
import { cn } from '@/lib/utils';

interface ProfileBadgeProps {
  profileName: string | null;
  className?: string;
}

export function ProfileBadge({ profileName, className }: ProfileBadgeProps) {
  const displayName = getDisplayProfileName(profileName);
  const colorClass = getProfileColorClass(profileName);

  return (
    <Badge variant="outline" className={cn(colorClass, 'dls-border-0', className)}>
      {displayName}
    </Badge>
  );
}
